import { styled } from '@mui/material';
import { Autocomplete, Button, Dropdown, Form, Icon, IconButton, Stack, Text, TextInput } from 'shell/components';
import { INSTITUTIONS, MAJORS, SEMESTER_OPTIONS } from 'utils/constants';

const LIST_OF_SCHOOLS = [...INSTITUTIONS, { name: 'Other' }].map(({ name }) => ({ key: name, value: name }));
const LIST_OF_SEMESTERS = SEMESTER_OPTIONS.map(({ key, value }) => ({ key, value }));
const LIST_OF_MAJORS = MAJORS.map(({ name }) => ({ key: name, value: name }));

const MobileCourseDetails = ({
    loading,
    form,
    isDirty,
    errors,
    onChange,
    onSubmit,
    setSelected,
    handleSettingDropDown,
}) => {
    return (
        <Stack spacing={4}>
            <Stack alignItems={'flex-start'} spacing={2}>
                <Button
                    aria-label={'back'}
                    startIcon={<Icon kind={'arrowLeft'} />}
                    size={'medium'}
                    variant={'tertiary'}
                    onClick={() => setSelected('')}
                >
                    Back
                </Button>
                <Stack alignItems={'center'} direction={'row'} spacing={4}>
                    <Text component={'h1'} variant={'h6'} weight={'semibold'}>
                        Course Details
                    </Text>
                    <Dropdown
                        id={'course-setting-dropdown'}
                        options={[{ key: 'delete-course', value: 'Delete Course' }]}
                        rootComponent={
                            <IconButton
                                aria-label={'more options'}
                                kind={'moreHorizontal'}
                                size={'medium'}
                                variant={'square'}
                            />
                        }
                        onSelect={handleSettingDropDown}
                    />
                </Stack>
            </Stack>
            <Form onSubmit={onSubmit}>
                <InputStack spacing={6}>
                    <Autocomplete
                        disableClearable
                        error={Boolean(errors.school)}
                        helperText={errors.school}
                        label={'School'}
                        options={LIST_OF_SCHOOLS}
                        required
                        value={form.school}
                        virtualized
                        onChange={(_, value) => onChange('school', value)}
                    />
                    {form.school.value === 'Other' ? (
                        <TextInput
                            sx={{ gridColumn: '1 / 3' }}
                            error={Boolean(errors.schoolOther)}
                            label={'Please Specify:'}
                            helperText={errors.schoolOther}
                            required
                            value={form.schoolOther}
                            onChange={(e) => onChange('schoolOther', e.target.value)}
                        />
                    ) : null}
                    <TextInput
                        error={Boolean(errors.faculty)}
                        helperText={errors.faculty}
                        label={'Faculty'}
                        required
                        value={form.faculty}
                        onChange={(e) => onChange('faculty', e.target.value)}
                    />
                    <TextInput
                        error={Boolean(errors.name)}
                        helperText={errors.name}
                        label={'Course Name'}
                        required
                        value={form.name}
                        onChange={(e) => onChange('name', e.target.value)}
                    />
                    <TextInput
                        error={Boolean(errors.section)}
                        helperText={errors.section}
                        label={'Section'}
                        value={form.section}
                        onChange={(e) => onChange('section', e.target.value)}
                    />
                    <Autocomplete
                        disableClearable
                        error={Boolean(errors.semester)}
                        helperText={errors.semester}
                        label={'Semester'}
                        options={LIST_OF_SEMESTERS}
                        required
                        value={form.semester}
                        onChange={(_, value) => onChange('semester', value)}
                    />
                    <Autocomplete
                        disableClearable
                        error={Boolean(errors.field_of_study)}
                        helperText={errors.field_of_study}
                        label={'Field of Study'}
                        options={LIST_OF_MAJORS}
                        required
                        value={form.field_of_study}
                        onChange={(_, value) => onChange('field_of_study', value)}
                    />
                </InputStack>
                <ButtonStack direction={'row-reverse'} spacing={2}>
                    <CustomButton disabled={!isDirty} loading={loading} type={'submit'}>
                        Save
                    </CustomButton>
                </ButtonStack>
            </Form>
        </Stack>
    );
};

const InputStack = styled(Stack)(({ theme }) => {
    return {
        margin: theme.spacing(6, 0, 2, 0),
    };
});

const ButtonStack = styled(Stack)(({ theme }) => {
    return {
        marginTop: theme.spacing(7),
        width: '100%',
        alignSelf: 'flex-end',
    };
});

const CustomButton = styled(Button)(({ theme }) => {
    return {
        width: '100%',
    };
});

export default MobileCourseDetails;
